import React, { useState, useEffect, useRef } from 'react';
import Breadcumb from '../../Layouts/Breadcumb'
import { Container, Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import Slider from "react-slick";
import { Link, useParams } from 'react-router-dom'
import Review from './Review';
import axios from 'axios';
import { Constants } from '../../endPoints';
import { jwtDecode } from 'jwt-decode';
import Swal from "sweetalert2";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const shakeStyle = `
@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}
`;

export default function Productdetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [sellerInfo, setSellerInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [accessToken, setAccessToken] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [showChatBox, setShowChatBox] = useState(false);
  const [chatMessage, setChatMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const chatBoxRef = useRef(null);
  const [guestName, setGuestName] = useState('');
  const [guestEmail, setGuestEmail] = useState('');
  const [showGuestForm, setShowGuestForm] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const fileInputRef = useRef(null);
  const history = useHistory();




  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    if (token) {
      const decoded = jwtDecode(token);
      setCurrentUserId(decoded.id);
      setAccessToken(token);
      setIsLoggedIn(true);
      fetchUserWishlist(token);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const fetchUserWishlist = async (token) => {
    const decodedToken = jwtDecode(token);
    const idUser = decodedToken.id;

    try {
      const response = await axios.get(`${Constants.getUserWishlist}/${idUser}`);
      console.log('API Response:', response.data);

      if (response.data.status === 1) {
        const wishlistProductIds = response.data.list.map((item) => item.idProduct);
        setWishlist(wishlistProductIds);
      }
    } catch (error) {
      console.error('Error fetching user wishlist:', error);
    }
  };

  // useEffect(() => {
  //   const fetchProduct = async () => {
  //     try {
  //       const response = await axios.get(`${Constants.getProductById}/${id}`);
  //       if (response.data.success === 1) {
  //         setProduct(response.data.data); // Set product data
  //         fetchImagesForProducts(response.data.data); // Fetch images for this product
  //       } else {
  //         console.log('Product fetch failed:', response.data);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching product details:', error);
  //     }
  //   };

  //   fetchProduct();
  // }, [id]);

    useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${Constants.getProductById}/${id}`
        );

        if (response.data.success === 1) {
          setProduct(response.data.data);
        } else {
          history.push("/listing");
        }
      } catch (error) {
        console.error(error);
        history.push("/listing");
      }
    };

    fetchProduct();
  }, [id]);


  useEffect(() => {
    if (product && product.idUser) {
      const fetchSellerInfo = async () => {
        try {
          const response = await axios.get(`${Constants.userInfoById}/${product.idUser}`);
          console.log('Seller info fetch response:', response); // Log the response
          if (response.data.status === 1) {
            setSellerInfo(response.data.data); // Set seller info
          } else {
            console.log('Seller info fetch failed:', response.data);
          }
        } catch (error) {
          console.error('Error fetching seller info:', error);
        }
      };

      fetchSellerInfo();
    }
  }, [product]); // Runs whenever the product data change


  useEffect(() => {
    if (product && product.id) {
      fetchImagesForProducts(product);  // Fetch images only if product is valid
    }
  }, [product]); // Ensure this runs when the product changes

  const fetchImagesForProducts = async (product) => {
    try {
      const response = await axios.get(`${Constants.getProductImagesById}/${product.id}`);
      if (response.data.status === 1) {
        const fetchedImages = Array.isArray(response.data.data)
          ? response.data.data.map(item => `${Constants.imageBaseURL}/${item.image}`).filter((value, index, self) => self.indexOf(value) === index) // Prevent duplicates
          : [];
        setProductImages(fetchedImages); // Store images in state
      } else {
        console.log('Product images fetch failed:', response.data);
      }
    } catch (error) {
      console.error('Error fetching product images:', error);
    }
  };

  const settings = {
    customPaging: function (i) {
      return (
        <img
          src={productImages[i]}
          alt={`Thumbnail ${i}`}
          style={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
            border: "1px solid #ddd",
            borderRadius: "4px"
          }}
        />
      );
    },
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: productImages.length > 1,
    draggable: productImages.length > 1,
    swipeable: productImages.length > 1
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;

    const stars = [];

    const starStyle = {
      color: "#fb923c", // orange-400
      marginRight: "4px",
      fontSize: "16px"
    };

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <i
          key={`full-${i}`}
          className="fa-solid fa-star"
          style={starStyle}
        ></i>
      );
    }

    if (halfStar) {
      stars.push(
        <i
          key="half"
          className="fa-solid fa-star-half-stroke"
          style={starStyle}
        ></i>
      );
    }

    while (stars.length < 5) {
      stars.push(
        <i
          key={`empty-${stars.length}`}
          className="fa-regular fa-star"
          style={starStyle}
        ></i>
      );
    }

    return stars;
  };


  useEffect(() => {
    // If there's a feedback message, set a timeout to hide it after 10 seconds
    if (feedbackMessage) {
      const timer = setTimeout(() => {
        setFeedbackMessage('');
        setFeedbackType('');
      }, 5000); // 10 seconds

      // Clear the timer if feedbackMessage changes before the timeout
      return () => clearTimeout(timer);
    }
  }, [feedbackMessage]);

  const handleWishlistClick = async (productId, isWished) => {
    if (!isLoggedIn) {
      setFeedbackMessage('Please log in to manage your wishlist.');
      setFeedbackType('error');
      return;
    }

    const decodedToken = jwtDecode(accessToken);
    const idUser = decodedToken.id;

    try {
      if (isWished) {
        // Remove from wishlist
        await axios.delete(`${Constants.deleteFromWishlist}/${productId}`, {
          data: { idUser }
        });
        setFeedbackMessage('Product removed from wishlist!');
        setFeedbackType('success');
      } else {
        // Add to wishlist
        await axios.post(Constants.addToWishlist, { idUser, idProduct: productId });
        setFeedbackMessage('Product added to wishlist!');
        setFeedbackType('success');
      }

      // Toggle locally
      setWishlist(prev => {
        if (isWished) {
          return prev.filter(id => id !== productId);
        } else {
          return [...prev, productId];
        }
      });

    } catch (err) {
      console.error('Error updating wishlist:', err);
      setFeedbackMessage('Something went wrong!');
      setFeedbackType('error');
    }
  };

  const isProductInWishlist = (productId) => wishlist.includes(productId);

  const fetchChatHistory = async () => {
    if (!accessToken || !product?.id) return;

    const decodedToken = jwtDecode(accessToken);
    const loggedInUserId = decodedToken.id;

    const sellerId = product.idUser; // seller ka id hai
    const buyerId = loggedInUserId;  // abhi login user buyer hai

    try {
      const response = await axios.post(`${Constants.getMyChatHistory}`, {
        sender_id: buyerId,
        receiver_id: sellerId,
        product_id: product.id
      });

      if (response.data.status === 1) {
        const messages = response.data.data.map(msg => ({
          text: msg.chat_msg,
          time: new Date(msg.created_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + ", " +
            new Date(msg.created_time).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
          sender: msg.sender_id == loggedInUserId ? 'me' : 'other',
          image_url: msg.image_url || null
        }));

        setChatHistory(messages);
      }
    } catch (error) {
      console.error("Error fetching chat:", error);
    }
  };


  useEffect(() => {
    let interval;

    if (showChatBox) {
      fetchChatHistory(); // initial load
      interval = setInterval(fetchChatHistory, 5000); // refresh every 5 seconds
    }

    return () => clearInterval(interval);
  }, [showChatBox, accessToken, product]);

  const handleSelectImage = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf"
    ];

    // ❌ Invalid file type
    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text: "Only PNG, JPG, JPEG and PDF files are allowed.",
        confirmButtonColor: "#B3902D"
      });

      e.target.value = ""; // reset input
      return;
    }

    // ✅ Optional: file size limit (example: 10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "File size should not exceed 10MB.",
        confirmButtonColor: "#B3902D"
      });

      e.target.value = "";
      return;
    }

    // ✅ Create preview
    file.preview = URL.createObjectURL(file);
    setSelectedImage(file);
  };

  const validateName = (name) => {
    // Only letters and spaces allowed
    const nameRegex = /^[A-Za-z\s]+$/;
    return nameRegex.test(name.trim());
  };

  const validateEmail = (email) => {
    // Standard email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  const handleGuestSubmit = async () => {
    // Name validation
    if (!guestName.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Name required',
        text: 'Please enter your name',
      });
      return;
    }

    if (!validateName(guestName)) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Name',
        text: 'Name should only contain letters and spaces',
      });
      return;
    }

    // Email validation
    if (!guestEmail.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Email required',
        text: 'Please enter your email',
      });
      return;
    }

    if (!validateEmail(guestEmail)) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Email',
        text: 'Please enter a valid email (example: user@example.com)',
      });
      return;
    }

    try {
      const res = await axios.post(Constants.guestLogin, {
        name: guestName,
        email: guestEmail
      });

      if (res.data.status === 1) {
        localStorage.setItem("authToken", res.data.accessToken);

        setAccessToken(res.data.accessToken);
        setIsLoggedIn(true);

        const decoded = jwtDecode(res.data.accessToken);
        setCurrentUserId(decoded.id);

        setShowGuestForm(false);
      }

    } catch (error) {
      console.error("Guest login error:", error);
    }
  };


  // const handleSendMessage = async () => {
  //   if (!chatMessage.trim()) {
  //     setMessageError(true);

  //     // Swal.fire({
  //     //   icon: 'warning',
  //     //   title: 'Message Required!',
  //     //   text: 'Please type a message.',
  //     //   confirmButtonColor: '#B3902D'
  //     // });

  //     return;
  //   }

  //   setMessageError(false);

  //   try {
  //     const decodedToken = jwtDecode(accessToken);
  //     const sender_id = decodedToken.id;
  //     const receiver_id = product?.idUser;

  //     if (sender_id === receiver_id) {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Oops!',
  //         text: 'You cannot send a message to yourself!',
  //         confirmButtonColor: '#B3902D'
  //       });
  //       return;
  //     }

  //     const formData = new FormData();
  //     formData.append('sender_id', sender_id);
  //     formData.append('receiver_id', receiver_id);
  //     formData.append('product_id', product.id);
  //     formData.append('msg', chatMessage);
  //     if (selectedImage) {
  //       formData.append('image', selectedImage);
  //     }

  //     // Local message push karo pehle (optimistic update)
  //     const tempMessage = {
  //       text: chatMessage,
  //       sender: 'me',
  //       time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + ", " +
  //         new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
  //       image_url: selectedImage ? URL.createObjectURL(selectedImage) : null // Local preview
  //     };
  //     setChatHistory(prev => [...prev, tempMessage]);

  //     // Scroll to bottom
  //     setTimeout(() => {
  //       if (chatBoxRef.current) {
  //         chatBoxRef.current.scrollTo({
  //           top: chatBoxRef.current.scrollHeight,
  //           behavior: "smooth"
  //         });
  //       }
  //     }, 100);

  //     // Ab actual server call
  //     const response = await axios.post(`${Constants.createChatMessage}`, formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //       }
  //     });

  //     if (response.data.success === 1) {
  //       setChatMessage('');
  //       setSelectedImage(null);

  //       // Optional: Refresh latest chat history (optional but good)
  //       fetchChatHistory();
  //     } else {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Failed!',
  //         text: 'Failed to send message.',
  //         confirmButtonColor: '#B3902D'
  //       });
  //     }

  //   } catch (error) {
  //     console.error('Error sending message:', error);
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Error sending message!',
  //       confirmButtonColor: '#B3902D'
  //     });
  //   }
  // };

  const handleSendMessage = async () => {

    if (!chatMessage.trim()) {

      // retrigger shake animation every click
      setMessageError(false);

      setTimeout(() => {
        setMessageError(true);
      }, 10);

      return;
    }

    setMessageError(false);

    try {

      const decodedToken = jwtDecode(accessToken);
      const sender_id = decodedToken.id;
      const receiver_id = product?.idUser;

      if (sender_id === receiver_id) {
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: 'You cannot send a message to yourself!',
          confirmButtonColor: '#B3902D'
        });
        return;
      }

      const formData = new FormData();
      formData.append('sender_id', sender_id);
      formData.append('receiver_id', receiver_id);
      formData.append('product_id', product.id);
      formData.append('msg', chatMessage);

      if (selectedImage) {
        formData.append('image', selectedImage);
      }

      const tempMessage = {
        text: chatMessage,
        sender: 'me',
        time:
          new Date().toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          }) +
          ", " +
          new Date().toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short'
          }),
        image_url: selectedImage
          ? URL.createObjectURL(selectedImage)
          : null
      };

      setChatHistory(prev => [...prev, tempMessage]);

      setTimeout(() => {
        if (chatBoxRef.current) {
          chatBoxRef.current.scrollTo({
            top: chatBoxRef.current.scrollHeight,
            behavior: "smooth"
          });
        }
      }, 100);

      const response = await axios.post(
        `${Constants.createChatMessage}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (response.data.success === 1) {

        setChatMessage('');
        setSelectedImage(null);

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        fetchChatHistory();

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: 'Failed to send message.',
          confirmButtonColor: '#B3902D'
        });
      }

    } catch (error) {
      console.error('Error sending message:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error sending message!',
        confirmButtonColor: '#B3902D'
      });
    }
  };

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTo({
        top: chatBoxRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
  }, [chatHistory]);

  return (
    <>
      <style>{shakeStyle}</style>
     <Breadcumb
  pagetitle={
    `${product?.selectionName || ""} ${product?.categoryName || ""}`.trim()
  }
  breadcrumbs={[
    { label: "Home", link: "/" },
    { label: "Shop", link: "/listing" },
    {
      label:
        `${product?.selectionName || ""} ${product?.categoryName || ""}`.trim()
    }
  ]}
/>
      <section className='productDetils'>
        <div className='container mx-auto px-4'>
          <Container>
            {feedbackMessage && (
              <div
                style={{
                  marginTop: "4px",       // mt-4
                  marginBottom: "16px",    // mb-4
                  padding: "16px",         // p-4
                  textAlign: "center",     // text-center
                  borderRadius: "6px",     // rounded-md
                  backgroundColor: feedbackType === 'success' ? "#D1FAE5" : "#FEE2E2", // green-100 / red-100
                  color: feedbackType === 'success' ? "#047857" : "#B91C1C",           // green-700 / red-700
                }}
              >
                {feedbackMessage}
              </div>
            )}


            {isLoading ? (
              <p>Loading...</p>
            ) : (
              product && (
                <Grid container spacing={4}>
                  <Grid item lg={6} md={5} sm={12} xs={12}>
                    <div className="product-slider" style={{ maxWidth: "500px", margin: "0 auto" }}>

                      {productImages.length > 0 ? (
                        <Slider {...settings}>
                          {productImages.map((image, index) => (
                            <div key={index} style={{ textAlign: "center" }}>
                              <img
                                src={image}
                                alt={`Product ${index}`}
                                style={{
                                  width: "100%",
                                  maxHeight: "400px",
                                  objectFit: "contain"
                                }}
                              />
                            </div>
                          ))}
                        </Slider>
                      ) : (
                        <img
                          src={`${Constants.imageBaseURL}product_default.png`}
                          alt="Default Product"
                          style={{
                            width: "100%",
                            maxHeight: "400px",
                            objectFit: "contain"
                          }}
                        />
                      )}

                    </div>
                  </Grid>
                  <Grid item lg={6} md={7} sm={12} xs={12}>
                    <div className='detilstitles'>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px", // gap between location and wishlist button
                        }}
                      >
                        {/* Location with golden background */}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#B3902D", // golden background
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "14px",
                            color: "#fff",               // text color white
                          }}
                        >
                          <Link
                            to=""
                            style={{
                              display: "flex",
                              alignItems: "center",
                              textDecoration: "none",
                              color: "inherit",
                            }}
                          >
                            <i
                              className="fa-solid fa-location-dot"
                              style={{
                                marginRight: "4px",
                                fontSize: "12px",
                              }}
                            ></i>
                            {product.countryName}, {product.stateName}
                          </Link>
                        </span>

                        {/* Wishlist Button */}
                        <button
                          onClick={() => handleWishlistClick(product.id, isProductInWishlist(product.id))}
                          style={{
                            width: "30px",                  // smaller/narrow button
                            height: "30px",           // circular
                            border: "1px solid #D1D5DB",    // gray border
                            borderRadius: "6px",           // circular
                            backgroundColor: "transparent",  // no background
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            padding: "0",
                          }}
                        >
                          <i
                            className="fa-regular fa-heart"
                            style={{
                              fontSize: "16px",              // smaller icon
                              color: isProductInWishlist(product.id) ? "red" : "black", // red if wishlisted, black if not
                            }}
                          ></i>
                        </button>
                      </div>
                      <h2 className='md:text-4xl text-2xl headningfont font-semibold'><Link to="">{product.selectionName} {product.categoryName}</Link></h2>
                      <h6 className='categoreyhdng'><Link to="">Category: {product.categoryName}</Link></h6>
                      <div className='flex items-center  tracking-widest'>
                        {renderStars(product.rating || 0)}
                        <span className="text-gray-600 text-sm">
                          {product.rating?.toFixed(1) || "0.0"}/5 • {product.totalReviews} Review{product.totalReviews > 1 ? 's' : ''}
                        </span>
                      </div>

                    </div>
                    <p
                      style={{
                        color: "#4B5563",
                        marginBottom: "32px",
                        lineHeight: "1.6",
                        fontSize: "16px",
                        wordBreak: "break-word"
                      }}
                      dangerouslySetInnerHTML={{ __html: product.description }}
                    />


                    <div>
                      <h2 className='md:text-3xl text-2xl text-[#B3902D] selerhdng mb-4 font-semibold'><Link to="">Seller Information</Link></h2>
                      <TableContainer>
                        <Table className='border' >
                          <TableBody>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-user mr-2"></i> Name</span></TableCell>
                              <TableCell>{sellerInfo ? `${sellerInfo.name}` : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-envelope mr-2"></i> Email</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.email : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i className="fa-solid fa-phone mr-2"></i> Phone</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.phone : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i className="fa-solid fa-globe mr-2"></i> Country</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.country : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i className="fa-solid fa-location-dot mr-2"></i> City</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.city : 'Loading...'}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>

                    </div>
                    <div className="mt-4 text-center">
                      <button
                        onClick={() => {
                          if (!isLoggedIn) {
                            setShowChatBox(true);
                            setShowGuestForm(true);
                            return;
                          }

                          if (currentUserId === sellerInfo?.id) {
                            Swal.fire({
                              icon: 'error',
                              title: 'Oops!',
                              text: 'You cannot chat with yourself!',
                              confirmButtonColor: '#B3902D'
                            });
                            return;
                          }

                          setShowChatBox(true);
                        }}
                        className="submit_btn"
                      >
                        Chat With Seller
                      </button>
                    </div>

                    {showChatBox && (
                      <div
                        style={{
                          position: "fixed",
                          bottom: window.innerWidth < 640 ? "70px" : "20px",
                          right: window.innerWidth < 640 ? "10px" : "40px",
                          width: window.innerWidth < 640 ? "260px" : "288px",
                          borderRadius: "6px",
                          border: "1px solid #ddd",
                          background: "#fff",
                          zIndex: 999,
                          boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
                        }}
                      >
                        <div
                          style={{
                            background: "#B3902D",
                            color: "#fff",
                            padding: "8px 16px",
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>
                            {sellerInfo?.firstname || "Seller"}
                          </span>

                          <button
                            onClick={() => setShowChatBox(false)}
                            style={{
                              color: "#fff",
                              fontWeight: "bold",
                              fontSize: "20px",
                              background: "none",
                              border: "none",
                              cursor: "pointer"
                            }}
                          >
                            &times;
                          </button>
                        </div>

                        {/* CHAT MESSAGES */}

                        {/* GUEST FORM */}
                        {showGuestForm ? (
                          <div style={{ padding: "12px" }}>
                            <input
                              type="text"
                              placeholder="Your Name"
                              value={guestName}
                              onChange={(e) => {
                                const value = e.target.value;

                                // Allow only letters and spaces while typing
                                if (/^[A-Za-z\s]*$/.test(value)) {
                                  setGuestName(value);
                                }
                              }}
                              style={{
                                width: "100%",
                                marginBottom: "8px",
                                padding: "8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px"
                              }}
                            />

                            <input
                              type="email"
                              placeholder="Your Email"
                              value={guestEmail}
                              onChange={(e) => setGuestEmail(e.target.value)}
                              required
                              style={{
                                width: "100%",
                                marginBottom: "8px",
                                padding: "8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px"
                              }}
                            />

                            <button
                              onClick={handleGuestSubmit}
                              style={{
                                width: "100%",
                                background: "#B3902D",
                                color: "#fff",
                                padding: "8px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer"
                              }}
                            >
                              Start Chat
                            </button>
                          </div>
                        ) : (
                          <>
                            {/* CHAT MESSAGES */}
                            <div
                              ref={chatBoxRef}
                              style={{
                                padding: "12px",
                                height: "240px",
                                overflowY: "auto"
                              }}
                            >
                              {chatHistory.map((msg, index) => (
                                <div
                                  key={index}
                                  style={{
                                    marginBottom: "12px",
                                    display: "flex",
                                    justifyContent: msg.sender === "me" ? "flex-end" : "flex-start"
                                  }}
                                >
                                  <div
                                    style={{
                                      maxWidth: "75%",
                                      padding: "8px 12px",
                                      borderRadius: "8px",
                                      fontSize: "14px",
                                      background: msg.sender === "me" ? "#dbeafe" : "#fed7aa",

                                      // ✅ FIX TEXT OVERFLOW
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      overflowWrap: "anywhere"
                                    }}
                                  >
                                    {msg.image_url && (
                                      <>
                                        {msg.image_url.toLowerCase().endsWith(".pdf") ? (
                                          <a
                                            href={msg.image_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              fontSize: "14px",
                                              color: "#2563eb",
                                              textDecoration: "none",
                                              display: "block",
                                              marginBottom: "6px"
                                            }}
                                          >
                                            📄 Open PDF
                                          </a>
                                        ) : (
                                          <img
                                            src={msg.image_url}
                                            alt="Chat"
                                            style={{
                                              width: "128px",
                                              borderRadius: "6px",
                                              marginBottom: "6px"
                                            }}
                                          />
                                        )}
                                      </>
                                    )}

                                    {msg.text && <div>{msg.text}</div>}

                                    <div
                                      style={{
                                        fontSize: "10px",
                                        color: "#6b7280",
                                        marginTop: "4px",
                                        textAlign: "right"
                                      }}
                                    >
                                      {msg.time}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}



                        {/* IMAGE PREVIEW (FIXED POSITION) */}
                        {selectedImage && (
                          <div
                            style={{
                              padding: "8px",
                              borderTop: "1px solid #ddd",
                              position: "relative"
                            }}
                          >
                            <button
                              onClick={() => {
                                setSelectedImage(null);

                                // reset file input
                                if (fileInputRef.current) {
                                  fileInputRef.current.value = "";
                                }
                              }}
                              style={{
                                position: "absolute",
                                top: "4px",
                                right: "4px",
                                background: "transparent",
                                border: "none",
                                color: "red",
                                cursor: "pointer",
                                fontSize: "16px",
                                fontWeight: "500",
                                padding: 0,
                                lineHeight: 1
                              }}
                            >
                              ✕
                            </button>

                            {selectedImage.type === "application/pdf" ? (
                              <a
                                href={selectedImage.preview}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  fontSize: "12px",
                                  color: "#000",
                                  textDecoration: "none"
                                }}
                              >
                                📄 {selectedImage.name}
                              </a>
                            ) : (
                              <img
                                src={selectedImage.preview}
                                alt="Preview"
                                style={{ width: "80px", borderRadius: "6px" }}
                              />
                            )}

                          </div>
                        )}

                        {/* INPUT SECTION */}
                        {!showGuestForm && (
                          <div
                            style={{
                              display: "flex",
                              borderTop: "1px solid #ddd"
                            }}
                          >
                            <div>
                              <input
                                ref={fileInputRef}
                                type="file"
                                accept=".png,.jpg,.jpeg,.pdf"
                                onChange={handleSelectImage}
                                style={{ display: "none" }}
                                id="imageUpload"
                              />

                              <label
                                htmlFor="imageUpload"
                                style={{
                                  background: "#B3902D",
                                  color: "#fff",
                                  padding: "0 12px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  height: "100%"
                                }}
                              >
                                <i className="fa fa-paperclip" style={{ fontSize: "12px" }}></i>
                              </label>
                            </div>

                            {/* <textarea
                              rows="1"
                              placeholder="Type your message here"
                              value={chatMessage}
                              onChange={(e) => {
                                setChatMessage(e.target.value);

                                if (e.target.value.trim()) {
                                  setMessageError(false);
                                }
                              }}
                              style={{
                                flexGrow: 1,
                                padding: "8px",
                                border: messageError ? "1px solid red" : "none",
                                outline: "none",
                                fontSize: "14px",
                                resize: "none",
                                animation: messageError ? "shake 0.3s" : "none"
                              }}
                            /> */}

                            <textarea
                              rows="1"
                              placeholder="Type your message here"
                              value={chatMessage}
                              onChange={(e) => {
                                setChatMessage(e.target.value);

                                if (e.target.value.trim()) {
                                  setMessageError(false);
                                }
                              }}
                              style={{
                                flexGrow: 1,
                                padding: "8px",
                                border: "1px solid",
                                borderColor: messageError ? "red" : "transparent",
                                outline: "none",
                                fontSize: "14px",
                                resize: "none",
                                transition: "border-color 0.2s ease",
                                animation: messageError ? "shake 0.3s" : ""
                              }}
                            />

                            <button
                              onClick={() => handleSendMessage()}
                              style={{
                                background: "#000",
                                color: "#fff",
                                padding: "0 12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "none",
                                cursor: "pointer"
                              }}
                            >
                              <i className="fa fa-paper-plane" style={{ fontSize: "12px" }}></i>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </Grid>
                </Grid>
              )
            )}
            <div className='botomreview'>
              <Review />
            </div>
          </Container>
        </div>
      </section>
    </>
  )
}
